function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgCompanyOvhcloudSm = function SvgCompanyOvhcloudSm(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 100 100",
    xmlSpace: "preserve"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M93.6 23.3c10.1 18.2 8.2 40.7-4.7 56.8H61.3l8.4-14.9H58.6L71.8 42H83l10.6-18.7zM39.3 80.1H11.4c-13.3-16.2-15.1-38.8-4.9-57l18.2 31.4 20-34.7h29.5L39.3 80.1z",
    style: {
      fill: "#000e9c"
    }
  }));
};
export default SvgCompanyOvhcloudSm;